module.exports = __webpack_public_path__ + "static/media/niranjan_core.d3d6cbb8.jpg";